var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isShowForwardPanel)?_c(_setup.Overlay,[_c(_setup.Transfer,{attrs:{"title":_setup.TUITranslateService.t('TUIChat.转发'),"isSearch":false,"isCustomItem":false,"list":_setup.customConversationList,"isHiddenBackIcon":_setup.isUniFrameWork},on:{"cancel":_setup.closeForwardPanel,"submit":_setup.onSubmit}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }